"use client";

import { ThemeProvider as OriginalThemeProvider } from "next-themes";

export function ThemeProvider({
  children,
  forcedTheme,
}: {
  children: React.ReactNode;
  forcedTheme?: string;
}) {
  return (
    <OriginalThemeProvider enableSystem defaultTheme="system" forcedTheme={forcedTheme}>
      {children}
    </OriginalThemeProvider>
  );
}
